import { faDoorClosed, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { infProdutoPerigosoInterface, SelectObjectRemoveInterface } from "../../../../interfaces";
import { useRef, useState } from "react";
import { ButtonRemover, ButtonTrash, JTable, JTBody, JTHead } from "../../../../components/Components";
import { getUuidV4, goToFocus } from "../../../../utils/utils";
import { useQuestion } from "../../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../../components/ModalMessage/useModalMessage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../app/store";
import {
    addProdutoPerigosoNFe, removeProdutoPerigosoNFe, removeProdutoPerigosoNFeTodos
} from "../../../../features/manifestoSlice";

interface formProps {
    id: number | string;
    show: boolean;
    handleClose: () => void;
}

const initialForm: infProdutoPerigosoInterface = {
    id: 0,
    nONU: '',
    xNomeAE: '',
    xClaRisco: '',
    grEmb: '',
    qTotProd: '',
    qVolTipo: ''
}

const NFesProdutoPerigoso: React.FC<formProps> = ({ id, show, handleClose }) => {
    const [form, setForm] = useState<infProdutoPerigosoInterface>(initialForm);
    const nONURef = useRef<HTMLInputElement>(null)
    const xNomeAERef = useRef<HTMLInputElement>(null)
    const xClaRiscoRef = useRef<HTMLInputElement>(null)
    const grEmbRef = useRef<HTMLInputElement>(null)
    const qTotProdRef = useRef<HTMLInputElement>(null)
    const qVolTipoRef = useRef<HTMLInputElement>(null)
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const manifesto = useSelector((state: RootState) => state.manifesto.manifesto);
    const dispatch = useDispatch();
    const [selecionado, setSelecionado] = useState<number | string>('');

    const validaPreenchimento = () => {
        if (form.nONU.trim() === "") {
            alertModal('Informe o Número ONU/UN.');
            goToFocus(nONURef);
            return false;
        }

        if (!/[0-9]{4}|ND/.test(form.nONU)) {
            alertModal('Número ONU/UN deve conter 4 números ou ND.');
            goToFocus(nONURef);
            return false;
        }

        if (form.xNomeAE.trim() === "") {
            alertModal('Informe o Nome apropriado para embarque do produto.');
            goToFocus(xNomeAERef);
            return false;
        }

        if (form.xClaRisco.trim() === "") {
            alertModal('Informe a Classe ou subclasse/divisão, e risco subsidiário/risco secundário.');
            goToFocus(xClaRiscoRef);
            return false;
        }

        if (form.grEmb.trim() === "") {
            alertModal('Informe o Grupo de Embalagem.');
            goToFocus(grEmbRef);
            return false;
        }

        if (form.qTotProd.trim() === "") {
            alertModal('Informe a Quantidade total por produto.');
            goToFocus(qTotProdRef);
            return false;
        }

        if (form.qVolTipo.trim() === "") {
            alertModal('Informe a Quantidade e Tipo de volumes.');
            goToFocus(qVolTipoRef);
            return false;
        }

        return true;
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addProdutoPerigosoNFe({
                nfeId: id,
                peri: {
                    ...form,
                    id: getUuidV4()
                }
            }))
            setForm(initialForm);
            goToFocus(nONURef);
        }
    }

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        if (manifesto.infMunDescarga.flatMap(item => item.infNFe)
            .filter(item => item?.id?.toString() === id.toString())
            .flatMap(item => item?.peri)?.length > 0) {
            setSelecionado(value.id);
            
            const confirmed = await confirm({
                message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(removeProdutoPerigosoNFe({
                    id: value.id,
                    nfeId: id
                }))
            }
            setSelecionado('');
        }
    }

    const handleRemoverTudo = async () => {
        if (manifesto.infMunDescarga.flatMap(item => item.infNFe)
            .filter(item => item?.id?.toString() === id.toString())
            .flatMap(item => item?.peri)?.length > 0) {
            const confirmed = await confirm({
                message: <>Remover todos ?</>,
                title: "Confirmação"
            });
            if (confirmed) {
                dispatch(removeProdutoPerigosoNFeTodos({
                    nfeId: id
                }))
            }
        }
    }

    return (<>
        <Modal show={show} onHide={handleClose} centered backdrop='static' size="lg" fullscreen={'xl-down'} scrollable>
            <Modal.Header closeButton className="py-2">
                <Modal.Title>Produto Perigoso ONU (Opcional)</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row className="mb-3 g-2">
                    <Col md={3}>
                        <Form.Group controlId="nfe-nONU">
                            <Form.Label>* Número ONU/UN</Form.Label>
                            <Form.Control name="nONU" maxLength={4} onChange={handleChange} ref={nONURef}

                                value={form.nONU} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="nfe-xNomeAE">
                            <Form.Label>* Nome Ap. Emb. Produto</Form.Label>
                            <Form.Control maxLength={150} name="xNomeAE" onChange={handleChange} ref={xNomeAERef}

                                value={form.xNomeAE} />
                        </Form.Group>
                    </Col>

                </Row>

                <Row className="mb-3 g-2">
                    <Col md>
                        <Form.Group controlId="nfe-xClaRisco">
                            <Form.Label>* Classe de Risco</Form.Label>
                            <Form.Control maxLength={40} name="xClaRisco" onChange={handleChange} ref={xClaRiscoRef}

                                value={form.xClaRisco} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="nfe-grEmb">
                            <Form.Label>* Grupo de Embalagem</Form.Label>
                            <Form.Control maxLength={6} name="grEmb" onChange={handleChange} ref={grEmbRef}

                                value={form.grEmb} />
                        </Form.Group>
                    </Col>

                </Row>

                <Row className="mb-3 g-2">
                    <Col md>
                        <Form.Group controlId="nfe-qTotProd">
                            <Form.Label>* Qtd. Total por Produto</Form.Label>
                            <Form.Control maxLength={20} name="qTotProd" onChange={handleChange} ref={qTotProdRef}

                                value={form.qTotProd} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group controlId="nfe-qVolTipo">
                            <Form.Label>* Qtd. e Tipo de Volumes</Form.Label>
                            <Form.Control maxLength={60} name="qVolTipo" onChange={handleChange} ref={qVolTipoRef}

                                value={form.qVolTipo} />
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex align-items-end">
                        <Button variant="primary" onClick={handleAdd} >
                            <FontAwesomeIcon icon={faPlus} /> Adicionar
                        </Button>
                    </Col>

                </Row>

                <JTable >
                    <JTHead>
                        <tr>
                            <th className="text-center">
                                <ButtonTrash onClick={() => handleRemoverTudo()} />
                            </th>
                            <th>Num ONU/UN</th>
                            <th>Classe Risco</th>
                            <th>Qtd. Total Produto</th>
                        </tr>
                    </JTHead>
                    <JTBody>

                        {manifesto.infMunDescarga.flatMap(item => item.infNFe)
                            .filter(nfe => nfe?.id?.toString() === id.toString())
                            .flatMap(item => item?.peri)?.map((item: any) => {
                                return (
                                    <tr key={item.id}
                                        className={(item.id?.toString()) === selecionado.toString() ? 'table-danger' : ''}>
                                        <td className="text-center">
                                            <ButtonRemover onClick={() =>
                                                handleRemover({ id: item.id.toString(), title: item.nONU })
                                            } />
                                        </td>
                                        <td>{item.nONU}</td>
                                        <td>{item.xClaRisco}</td>
                                        <td>{item.qTotProd}</td>
                                    </tr>
                                )
                            })}

                    </JTBody>
                </JTable>

                {ConfirmModal}
                {ModalMessageEl}
            </Modal.Body>

            <Modal.Footer className="py-2">
                <Button variant="secondary" onClick={handleClose} >
                    <FontAwesomeIcon icon={faDoorClosed} /> Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    </>)
}
export default NFesProdutoPerigoso;